import { useState } from 'react';
import { Link } from 'react-router-dom';
import { KeyRound, ArrowLeft } from 'lucide-react';
import { authService } from '../../shared/services';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      const response = await authService.forgotPassword(email);
      setSuccess(response.message || 'Se o e-mail estiver cadastrado, você receberá as instruções para redefinir a senha.');
    } catch (err: unknown) {
      const axiosErr = err as {
        message?: string;
        code?: string;
        response?: { status?: number; data?: { message?: string } };
      };
      const message =
        axiosErr.response?.data?.message ||
        (axiosErr.code === 'ERR_NETWORK'
          ? 'Não foi possível conectar à API. Verifique sua conexão e o certificado SSL, depois tente novamente.'
          : 'Não foi possível enviar o e-mail. Tente novamente.');
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-600 to-primary-800 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-4">
            <KeyRound className="text-primary-600" size={32} />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Universidade Salt</h1>
          <p className="text-primary-100">Recuperação de senha</p>
        </div>

        <div className="bg-white rounded-xl shadow-2xl p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Esqueceu a senha?</h2>
          <p className="text-sm text-gray-600 mb-6">
            Informe seu e-mail e enviaremos um link para redefinir a senha.
          </p>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
              {error}
            </div>
          )}

          {success && (
            <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg text-green-700 text-sm">
              {success}
            </div>
          )}

          {!success && (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                  placeholder="seu@email.com"
                />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="w-full btn-primary py-3 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? 'Enviando...' : 'Enviar link de recuperação'}
              </button>
            </form>
          )}

          <div className="mt-6">
            <Link
              to="/login"
              className="inline-flex items-center text-sm text-primary-600 hover:text-primary-700"
            >
              <ArrowLeft size={16} className="mr-1" />
              Voltar ao login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
